
export default class ScoolUserInviteModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;

    this.email = data.email || '';
    this.school = data.school || '';
    this.role = data.role || '';
    this.first_name = data.first_name || '';
    this.last_name = data.last_name || '';
    this.invite_token = data.invite_token || '';
  }
}
